<div class="control-label">
  <app-form-lablel [label]="label"> </app-form-lablel>
</div>
<label [for]="id" class="file-btn btn-outline-secondary btn-file"
  >Adjuntar archivo
  <mat-icon [inline]="true">attach_file</mat-icon>
</label>
<input
  class="input-hidden"
  type="file"
  [id]="id"
  #file="ngModel"
  ngModel
  (change)="changeFile($event, $event.target.files[0])"
  required
/>
<button
  mat-flat-button
  type="button"
  class="btn-lg ml-15 delete-button"
  data-tooltip="Eliminar Archivo Cargado"
  (click)="resetFile()"
>
  <svg-icon
    class="icon"
    src="../../../../../assets/icons/borrar.svg"
    [svgStyle]="{
      'width.rem': 0.93,
      'height.rem': 0.87,
      position: 'relative',
      'left.rem': 0.15,
      fill: 'white'
    }"
  ></svg-icon>
</button>
<div *ngIf="fileName" class="col-12">
  <p class="description-page-endosos">{{ fileName }}</p>
</div>
<div class="col-12 py-2" *ngIf="file.invalid && file.dirty">
  <mat-error class="row-3" *ngIf="!IsFileSupported"
    >Adjunte un archivo válido, formatos soportados:<strong>
      <span *ngFor="let tipo of supportedFileTypes">&nbsp;.{{ tipo }}</span>
    </strong>
  </mat-error>
  <mat-error class="row-3" *ngIf="!FileSizeIsValid"
    >Tamaño máximo permitido:&nbsp;<strong
      >{{ maxFileSizeInMB }}mb</strong
    ></mat-error
  >
</div>
